import { produce } from 'immer';
import { orderBy } from 'lodash';

import { UpdateInternalMarketer } from '../../../actions/marketer/internal/updateInternalMarketer';
import { routeMarketerProductsToKeyMap } from '../../../service/MarketersHelper';
import { MarketerProduct, MarketerState } from '../../../typings/marketers';

export function updateInternalMarketer(state: MarketerState, action: UpdateInternalMarketer): MarketerState {
    return produce(state, draft => {
        let ownProducts = action.marketer.ownProducts;

        draft.marketer.id = action.marketer.id;
        draft.marketer.login = action.marketer.login;
        draft.marketer.fullName = action.marketer.fullName;

        if (action.productsSortParams) {
            ownProducts = orderBy<MarketerProduct>(
                ownProducts,
                [routeMarketerProductsToKeyMap[action.productsSortParams.key]],
                [action.productsSortParams.direction]
            );
        }

        draft.marketer.ownProducts = ownProducts.map((item: MarketerProduct) => ({
            id: item.id,
            productName: item.productName,
            productLogin: item.productLogin,
            access: item.access,
            placeIds: item.placeIds,
            isSaved: true,
            isRemoving: false
        }));
    });
}
